import { EntitiesList } from './EntitiesList'
import { EntityData } from './EntityData'
import { EntityGroupsAdded } from './EntityGroupsAdded'
import { EntityGroupsAll } from './EntityGroupsAll'
import { EntityGroupsCancel } from './EntityGroupsCancel'
import { EntityGroupsCreate } from './EntityGroupsCreate'
import { EntityGroupsUpdate } from './EntityGroupsUpdate'

export { EntitiesList, EntityData, EntityGroupsAdded, EntityGroupsAll, EntityGroupsUpdate, EntityGroupsCancel, EntityGroupsCreate }

export const emptyEntity: any = {
  // AdGroupId: -1,
  GroupName: '',
  Description: '',
  DistinguishedName: '',
  WhenChanged: '',
  WhenCreated: '',
  Members: {
    Users: [],
    Memberships: [],
    CeGroups: [],
    Pharmacies: [],
    QlikApps: [],
    QlikStreams: [],
    OmitGroups: [],
    Distributors: [],
    OtherGroups: [],
  },
}
